import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Structure } from '@docma-mm-core/structure/structure';
import { TreeNode, TreeOptions, TreeService } from '@mydocma/component-library/src/lib/tree';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

interface StructureNode {
  expandable: boolean;
  name: string;
  level: number;
  structure: Structure;
}

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-structure-tree',
  templateUrl: './mm-structure-tree.component.html',
  styleUrls: ['./mm-structure-tree.component.scss']
})
export class MmStructureTreeComponent implements OnInit, OnDestroy {

  @Input() structures: Structure[];
  @Input() selected: Structure;
  @Output() structureClick = new EventEmitter<Structure>();

  treeOptions: TreeOptions;
  treeService: TreeService;

  constructor() {
    this.treeOptions = {
      suppressChildrenCount: true,
      collapseAllTopLevel: 1,
      getNodeId: (data: Structure) => data.Id.toString(),
      getNodeChildren: (node: TreeNode) => node.data.Children,
      getNodeInfo: (node: TreeNode) => {
        return {
          text: [node.data.Name1, node.data.Name2].filter(Boolean).join(" - "),
          expanded: node.data.Level < this.structures[0].Level+1,
          selectable: node.data.selectable,
          hidden: node.data.hidden
        };
      },
      onReady: (ts)=> {
        this.treeService = ts;
        this.treeService.selectedNode$
        .pipe(untilDestroyed(this))
        .subscribe(n => {
          if (n) {
            this.treeService.showNode(n);
          }
        })
      },
      getNodeClass(node) {
        if(node.data.selectable === false) {
          return "mydocma-mm-readonly-node";
        }
      },
    }
  }

  ngOnDestroy(): void {
  }

  ngOnInit() {
  }

  onClick(node: TreeNode) {
    if (node) {
      this.structureClick.emit(node.data);
    }
  }
}
